/**
 * Resolve a media URL to a stable, browser-loadable URL.
 *
 * Preference order:
 *   1. r2Key (if present) → /api/media/<key>   — permanent mirrored copy
 *   2. live source → /api/img-proxy?url=…      — IG CDN passthrough w/ spoofed Referer
 *
 * R2-backed assets never expire and stream with Range support, so reels
 * play inline via a plain <video> tag instead of needing the IG embed.
 */
export function imgProxy(
  url: string | null | undefined,
  r2Key?: string | null,
): string | undefined {
  if (r2Key) return `/api/media/${r2Key}`;
  if (!url) return undefined;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/')) return url;
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') return url;
  } catch {
    return url;
  }
  return `/api/img-proxy?url=${encodeURIComponent(url)}`;
}
